module.exports = __webpack_public_path__ + "static/img/tab-banner1.81a6731.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/6/tab-banner1.png
// module id = FZ03
// module chunks = 1